import { render, staticRenderFns } from "./IntractAppBar.vue?vue&type=template&id=4fc64712&scoped=true"
import script from "./IntractAppBar.vue?vue&type=script&lang=js"
export * from "./IntractAppBar.vue?vue&type=script&lang=js"
import style0 from "./IntractAppBar.vue?vue&type=style&index=0&id=4fc64712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc64712",
  null
  
)

export default component.exports